<template>
  <div class="my-repayments" v-if="repayData">
    <div class="header">
      <span>대출 현황</span>
    </div>
    <v-card class="summary">
      <v-card-title>
        <span>{{ loan.offer.period_in_days }}일 상환</span>
        <span>{{ status(loan.left_amount) }}</span>
      </v-card-title>
      <hr />
      <v-card-subtitle>
        <div class="scheudle">
            <strong>실행일 {{ loan.executed_at | dateFormat }} ~ 만기일  {{ loan.expirationDate }}</strong>
        </div>
        <div>
          <div class="amount top">
            <strong>대출원금 {{ loan.amount | commaFormat }} 원</strong>
          </div>
          <div class="amount down">
            <strong>대출잔액 {{ loan.left_amount | commaFormat }} 원</strong>
          </div>
        </div>
      </v-card-subtitle>
    </v-card>
    <v-card class="delay-amount mb-5" v-if="delayAmount">
      <v-card-title>
        착한투자자 유예원금 <v-spacer></v-spacer>
        <span>{{ delayAmount | toCurrency }} 원</span>
      </v-card-title>
    </v-card>
    <MyRepaymentBlock
      class="my-repayments__block"
      v-for="(data, index) in repayData"
      :key="index"
      :repay-data="data"
    />
  </div>
  <MyRepaymentNoData v-else-if="isPageLoading == false" />
</template>
<script>
import MyRepaymentBlock from './components/repayments/MyRepaymentBlock'
import MyRepaymentNoData from './components/repayments/MyRepaymentNoData'
import loanApi from '@/api/now/loanApi'
import LoanService from '@/service/loan/LoanService'

import moment from 'moment'

export default {
  components: { MyRepaymentBlock, MyRepaymentNoData },
  data() {
    return {
      isPageLoading: true,
      repayData: null,
      loan: null,
      uuid: this.$route.params.uuid,
      onGoingLoan: null,
      delayAmount: 0,
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '비상금 상환 내역')

    await this.getOnGoingLoan()
    await this.setDelayAmount()
    try {
      let { data } = await loanApi.getLoanRepayments(this.uuid)
      if (data && data.length > 0) {
        this.repayData = data
      }
    } catch (e) {
      console.error(e, 'getLoanRepaymentsHistory')
    } finally {
      this.isPageLoading = false
    }
  },
  computed: {
    status() {
      return leftAmount => leftAmount > 0 ? '상환중' : '상환완료'
    },
  },
  methods: {
    async getOnGoingLoan() {
      try {
        this.onGoingLoan = await LoanService.getLoanOngoingForRepayment()
        this.loan = this.onGoingLoan.filter((loan) => loan.uuid === this.uuid)[0]
        this.loan.expirationDate = moment(this.loan.executed_at, 'YYYY-MM-DD').add(this.loan.offer.period_in_days, 'days').format('YYYY-MM-DD')
      } catch (e) {
        console.log('getOnGoingLoan', e)
      }
    },
    async setDelayAmount() {
      this.delayAmount = this.onGoingLoan
        .filter((loan) => loan.status === 'executed' && loan.is_in_graceful)
        .reduce((sum, loan) => {
          return (sum += loan.left_amount)
        }, 0)
    },
  },
}
</script>
<style lang="scss" scoped>
.delay-amount {
  background-color: #25aee1;

  .v-card__title {
    color: white;
    font-weight: 600;

    @media screen and (max-width: 991px) {
      font-size: 15px;
    }
  }
}

.header {
  margin-top: 25px;
  margin-bottom: 25px;
  span {
    font-size: 1.2rem;
    font-weight: 900;
  }
}

.v-card.summary {
    margin-bottom: 20px;

    .theme--light.v-btn.v-btn--icon {
      color: #ffffff;
    }

    hr {
      color: #f2f2f2;
    }
    .v-card__title {
      font-size: 1rem;
      justify-content: space-between;
      padding-right: 25px;
      padding-left: 25px;

      span {
        font-weight: 900;
      }
    }
    .v-card__subtitle {
      color: #333333;
      padding-top: 11px;
      padding-bottom: 11px;
      padding-right: 25px;
      padding-left: 25px;
      line-height: 25px;

      .scheudle {
        text-align: right;
        strong {
          font-size: 0.9rem;
          font-weight: 900;
          color: #333333;
        }
      }

      .amount {
        text-align: right;
        strong {
          font-size: 1rem;
          font-weight: 900;
          color: #333333;
        }
      }
    }

    .v-card__actions {
      padding: 0;
    }
  }

.my-repayments {
  margin: 22px 25px 0;

  &__block:not(:last-of-type) {
    margin-bottom: 22px;
  }

  &__block:last-of-type {
    margin-bottom: 70px;
  }
}
</style>
